module.exports = __webpack_public_path__ + "img/bob-kim.c0523bc7.jpg";